import { createSlice } from "@reduxjs/toolkit";
import {
    createNavigation,
    deleteNavigation,
    getNavigationDropdownList,
    getNavigations,
    updateNavigation,
} from "./navigationThunk";

const initialState = {
    loading: false,

    navigationList: [],

    navigationDropdownList: [],

    pagination: {},

    error: null,

    // Paginated navigation list cache
    // {
    //     "companyId=1&pageNumber=1&pageSize=10": {
    //         data: [],
    //         pagination: {},
    //         timestamp: 123456789
    //     }
    // }
    cache: {},

    // Navigation dropdown cache
    // {
    //     "companyId=1": {
    //         data: [],
    //         timestamp: 123456789
    //     }
    // }
    dropdownCache: {},
};

const navigationSlice = createSlice({
    name: "navigations",

    initialState,

    reducers: {
        // ==========================================
        // CLEAR ALL NAVIGATION CACHE
        // ==========================================

        clearNavigationCache: (state) => {
            state.cache = {};
            state.dropdownCache = {};
        },

        // ==========================================
        // CLEAR PAGINATED CACHE BY KEY
        // ==========================================

        clearNavigationCacheByKey: (state, action) => {
            delete state.cache[action.payload];
        },

        // ==========================================
        // CLEAR DROPDOWN CACHE
        // ==========================================

        clearNavigationDropdownCache: (state) => {
            state.dropdownCache = {};
        },
    },

    extraReducers: (builder) => {
        builder

            // ==========================================
            // GET NAVIGATIONS
            // ==========================================

            .addCase(getNavigations.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(getNavigations.fulfilled, (state, action) => {
                state.loading = false;

                state.navigationList = action.payload.data;

                state.pagination = action.payload.pagination;

                // Save only fresh API data into cache
                if (!action.payload.fromCache) {
                    state.cache[action.payload.cacheKey] = {
                        data: action.payload.data,
                        pagination: action.payload.pagination,
                        timestamp: Date.now(),
                    };
                }
            })

            .addCase(getNavigations.rejected, (state, action) => {
                state.loading = false;

                state.error = action.payload;
            })

            // ==========================================
            // CREATE NAVIGATION
            // ==========================================

            .addCase(createNavigation.fulfilled, (state) => {
                // Navigation list cache is stale
                state.cache = {};

                // Dropdown cache is also stale
                state.dropdownCache = {};
            })

            // ==========================================
            // UPDATE NAVIGATION
            // ==========================================

            .addCase(updateNavigation.fulfilled, (state) => {
                // Navigation list cache is stale
                state.cache = {};

                // Dropdown cache is also stale
                state.dropdownCache = {};
            })

            // ==========================================
            // DELETE NAVIGATION
            // ==========================================

            .addCase(deleteNavigation.fulfilled, (state) => {
                // Navigation list cache is stale
                state.cache = {};

                // Dropdown cache is also stale
                state.dropdownCache = {};
            })

            // ==========================================
            // NAVIGATION DROPDOWN LIST
            // ==========================================

            .addCase(
                getNavigationDropdownList.fulfilled,
                (state, action) => {
                    state.navigationDropdownList =
                        action.payload.data;

                    // Save only fresh API data into cache
                    if (!action.payload.fromCache) {
                        state.dropdownCache[
                            action.payload.cacheKey
                        ] = {
                            data: action.payload.data,
                            timestamp: Date.now(),
                        };
                    }
                }
            );
    },
});

export const {
    clearNavigationCache,
    clearNavigationCacheByKey,
    clearNavigationDropdownCache,
} = navigationSlice.actions;

export default navigationSlice.reducer;